module.exports = __webpack_public_path__ + "img/gc_country_flag_mt.2804d174.svg";